//Used to initialize the navigation only in lieu of having the whole bundle on the homepage to help load time
document.addEventListener('DOMContentLoaded', function () {
  navigation();
});
